export { default as TrustpilotCustom } from "./TrustpilotCustom";
